export default __webpack_public_path__ + "static/media/adv-bg.77abd369.png";